import { baseURL } from "../../util/config"

export const getFullImageUrl = imgPath => {
  
  if (!imgPath) return ''
  
  if (imgPath?.includes('http')) {
      return imgPath
    }
  const normalizedPath = imgPath.replace(/\\/g, '/')

  return `${baseURL}${normalizedPath}`
}
